import React, { ReactElement, useEffect, useState } from "react";
import { VisState } from "../../helpers/vis";
import ReactVisBase from "../../components/ReactVisBase";
import Schedule from "./Schedule";
import AddEventForm from "./AddEventForm";
import "./Vis.css";
import EventsTable from "./EventsTable";
import useWatchDeviceRegistersRawData from "../../hooks/use-watch-registers-raw-data";
import { getEvents, getRegisters } from "./data";
import GlobalSpinner from "../../components/GlobalSpinner";
import { Settings } from ".";

export default function Vis({ state }: { state: VisState<Settings> }): ReactElement {
  return (
    <ReactVisBase state={state}>
      <VisSmart state={state} />
    </ReactVisBase>
  );
}

export function VisSmart({ state }: { state: VisState<Settings> }): ReactElement {
  const [showSpinner, setShowSpinner] = useState(false);

  const deviceId = state.org.getDefaultDeviceId();
  if (!deviceId) {
    throw new Error("No default device");
  }
  const startAddress = state.settings.startAddress;
  const device = state.org.devices[deviceId];
  const registers = getRegisters(startAddress);

  const data = useWatchDeviceRegistersRawData(
    state.data,
    state.params,
    device.netId,
    device.modbusUnitId,
    [...registers, ["deviceType", "0", 10]],
    true,
  );

  const events = getEvents(data);
  useEffect(() => {
    if (data.deviceType === undefined || isNaN(Number(data.deviceType))) {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [data.deviceType]);

  // TODO_FUTURE: Check AM/PM switch in time inputs
  return (
    <div className="vis-light-schedule">
      <div className="schedule">
        <Schedule events={events} />
      </div>
      <div className="settings">
        <AddEventForm
          vis={state}
          showSpinner={setShowSpinner}
          device={device}
          registers={registers}
        />
      </div>
      <div className="events-table-container">
        <EventsTable vis={state} events={events} showSpinner={setShowSpinner} device={device} />
      </div>
      <GlobalSpinner isView={showSpinner} />
    </div>
  );
}
